import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";

const UnblockDateModal = ({ show, onHide, onConfirm, error }) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState(null);
  const [validationError, setValidationError] = useState(null);

  useEffect(() => {
    if (!show) {
      setReason("");
      setLocalError(null);
      setValidationError(null);
      setLoading(false);
    }
  }, [show]);

  useEffect(() => { setLocalError(error || null); }, [error]);

  const handleConfirm = async () => {
    setLocalError(null);
    setValidationError(null);

    const trimmed = reason && reason.trim();
    if (!trimmed) {
      setValidationError("Please provide a reason for unblocking.");
      return;
    }

    setLoading(true);
    try {
      const combinedReason = `Date Unblocked. ${trimmed}`;
      await onConfirm(combinedReason);
    } catch (err) {
      setLocalError(err?.message || JSON.stringify(err) || "Unknown error");
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => {
    const val = e.target.value;
    setReason(val);
    if (validationError && val.trim()) setValidationError(null);
    if (localError) setLocalError(null);
  };

  const isConfirmDisabled = loading || !(reason && reason.trim().length > 0);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Unblock Reservation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {localError && <Alert variant="danger" onClose={() => setLocalError(null)} dismissible>{localError}</Alert>}

        <Form>
          <Form.Group controlId="rejectReason">
            <Form.Label>Please provide a reason for the unblocking</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={reason}
              onChange={onChange}
              placeholder="Explain why this reservation is being unblocked (required)"
              maxLength={250}
              disabled={loading}
              required
              aria-required={true}
              isInvalid={!!validationError}
            />
            <Form.Control.Feedback type="invalid">{validationError}</Form.Control.Feedback>
            <Form.Text muted>{reason.length}/250</Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>Cancel</Button>
        <Button variant="danger" onClick={handleConfirm} disabled={isConfirmDisabled}>
          {loading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />{" "}
              Unblocking..
            </>
          ) : (
            "Confirm Unblock"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnblockDateModal;
